import axios from '@/axios'

export default {
  calculate(payload){
    return axios.post(`/recapitulations`, payload)
  },
  export(payload){
    return axios.post(`/recapitulations/export`, payload)
  },  
}